import { Icon } from '@chakra-ui/react';

const PCListIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M29.07,6.09c-0.16,0.23-0.38,0.28-0.65,0.28c-6.25-0.01-12.5,0-18.75,0c-0.09,0-0.19,0.01-0.28-0.01
		C9.17,6.33,9.01,6.14,9.02,5.91c0.01-0.24,0.14-0.38,0.37-0.42c0.09-0.02,0.19-0.01,0.28-0.01c6.25,0,12.5,0,18.75,0
		c0.27,0,0.49,0.05,0.65,0.28C29.07,5.87,29.07,5.98,29.07,6.09z"/>
			<path class="st0" d="M29.07,15.67c-0.16,0.23-0.38,0.29-0.65,0.28c-6.26-0.01-12.51,0-18.77,0c-0.09,0-0.19,0.01-0.28-0.01
		c-0.22-0.05-0.36-0.2-0.36-0.44c0-0.24,0.13-0.38,0.36-0.44c0.09-0.02,0.19-0.01,0.28-0.01c6.26,0,12.51,0,18.77,0
		c0.27,0,0.49,0.05,0.65,0.28C29.07,15.45,29.07,15.56,29.07,15.67z"/>
			<path class="st0" d="M29.07,25.25c-0.15,0.22-0.36,0.28-0.62,0.28c-6.27-0.01-12.54,0-18.81,0c-0.08,0-0.17,0.01-0.25-0.01
		c-0.23-0.05-0.36-0.19-0.37-0.42c-0.01-0.23,0.15-0.42,0.37-0.45c0.09-0.01,0.19-0.01,0.28-0.01c6.25,0,12.5,0,18.75,0
		c0.27,0,0.49,0.05,0.65,0.28C29.07,25.03,29.07,25.14,29.07,25.25z"/>
			<path class="st0" d="M16.64,3.98c-2.3,0-4.59,0-6.89,0c-0.11,0-0.22,0-0.34-0.01c-0.24-0.02-0.38-0.16-0.4-0.39
		C9,3.32,9.13,3.17,9.36,3.1c0.1-0.03,0.2-0.02,0.3-0.02c4.66,0,9.31,0,13.97,0c0.13,0,0.26,0.01,0.38,0.06
		c0.2,0.08,0.28,0.24,0.25,0.45c-0.02,0.2-0.14,0.35-0.35,0.38c-0.12,0.02-0.24,0.02-0.36,0.02C21.25,3.98,18.95,3.98,16.64,3.98z"
			/>
			<path class="st0" d="M16.65,13.56c-2.3,0-4.59,0-6.89,0c-0.1,0-0.21,0-0.31-0.01c-0.26-0.02-0.43-0.19-0.43-0.42
		c-0.01-0.25,0.16-0.44,0.42-0.47c0.08-0.01,0.17-0.01,0.25-0.01c4.64,0,9.28,0,13.91,0c0.06,0,0.11,0,0.17,0
		c0.31,0.01,0.5,0.19,0.51,0.45c0.01,0.26-0.19,0.45-0.5,0.45c-0.48,0.01-0.95,0-1.43,0C20.45,13.56,18.55,13.56,16.65,13.56z"/>
			<path class="st0" d="M16.65,23.14c-2.3,0-4.61,0-6.91,0c-0.11,0-0.22,0-0.33-0.02c-0.22-0.03-0.35-0.17-0.37-0.39
		C9,22.52,9.1,22.35,9.31,22.28c0.1-0.04,0.22-0.04,0.33-0.04c4.68,0,9.35,0,14.03,0c0.12,0,0.25,0.01,0.35,0.06
		c0.2,0.08,0.28,0.25,0.25,0.45c-0.02,0.2-0.14,0.35-0.35,0.38c-0.12,0.02-0.24,0.02-0.36,0.02C21.26,23.14,18.95,23.14,16.65,23.14
		z"/>
			<path class="st0" d="M13.78,17.45c1.33,0,2.65,0,3.98,0c0.07,0,0.13,0,0.2,0c0.38,0.01,0.59,0.17,0.58,0.46
		c0,0.28-0.22,0.45-0.59,0.45c-2.78,0-5.56,0-8.35,0c-0.42,0-0.67-0.28-0.56-0.6c0.1-0.26,0.32-0.31,0.57-0.31
		C11,17.45,12.39,17.45,13.78,17.45z"/>
			<path class="st0" d="M13.78,27.03c1.34,0,2.67,0,4.01,0c0.07,0,0.15,0,0.22,0c0.33,0.02,0.53,0.19,0.52,0.46
		c-0.01,0.26-0.21,0.44-0.54,0.44c-2.81,0-5.62,0-8.43,0c-0.26,0-0.47-0.09-0.53-0.36c-0.06-0.23,0.04-0.42,0.25-0.5
		c0.12-0.05,0.27-0.05,0.41-0.05C11.06,27.03,12.42,27.03,13.78,27.03z"/>
			<path class="st0" d="M13.78,8.78c-1.37,0-2.74,0-4.12,0c-0.12,0-0.25-0.01-0.36-0.05C9.1,8.66,9,8.49,9.02,8.27
		C9.05,8.05,9.18,7.91,9.4,7.89c0.1-0.01,0.2-0.02,0.31-0.02c2.71,0,5.42,0,8.12,0c0.09,0,0.19,0,0.28,0.01
		c0.25,0.03,0.43,0.21,0.42,0.44c-0.01,0.25-0.15,0.4-0.39,0.45c-0.09,0.02-0.19,0.01-0.28,0.01C16.51,8.78,15.14,8.78,13.78,8.78z"
			/>
			<circle class="st0" cx="3.86" cy="5.93" r="2.93" />
			<circle class="st0" cx="3.86" cy="15.05" r="2.93" />
			<path class="st0" d="M3.86,22.18c-1.62,0-2.93,1.31-2.93,2.93c0,1.62,1.31,2.93,2.93,2.93c1.62,0,2.93-1.31,2.93-2.93
		C6.79,23.49,5.48,22.18,3.86,22.18z M3.86,27.01c-1.05,0-1.89-0.85-1.89-1.9c0-1.05,0.85-1.89,1.89-1.89c1.05,0,1.9,0.85,1.9,1.89
		C5.76,26.16,4.91,27.01,3.86,27.01z"/>
		</g>

	</Icon>
);

export default PCListIcon;
